import { render, staticRenderFns } from "./InventoryItemPurchaseSupplierCard.vue?vue&type=template&id=59f6782c&scoped=true&"
import script from "./InventoryItemPurchaseSupplierCard.vue?vue&type=script&lang=js&"
export * from "./InventoryItemPurchaseSupplierCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItemPurchaseSupplierCard.vue?vue&type=style&index=0&id=59f6782c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f6782c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VTooltip})
